import { render, staticRenderFns } from "./smedia.vue?vue&type=template&id=3f8857f6&"
import script from "./smedia.vue?vue&type=script&lang=js&"
export * from "./smedia.vue?vue&type=script&lang=js&"
import style0 from "./smedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports